// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MoneyIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MoneyIcon" ref={forwardedRef} {...props}>
      <path d="M2.979 4.93a1 1 0 0 0-.47 1.632l1.62 1.79-1.15.325a1 1 0 0 0-.47 1.633l1.62 1.79-1.15.325a1 1 0 0 0-.47 1.633l3.463 3.827a1 1 0 0 0 1.013.292l10.246-2.892a1 1 0 0 0 .47-1.633l-1.62-1.79 1.15-.325a1 1 0 0 0 .47-1.633l-1.62-1.79 1.15-.325a1 1 0 0 0 .47-1.633l-3.463-3.827a1 1 0 0 0-1.013-.291zm6.21 3.674L6.843 9.266 3.98 6.101l2.445-.69zm-2.204 2.077 2.817-.795v2.293l-2.959.835L3.98 9.849l1.197-.338.794.878a1 1 0 0 0 1.014.292m0 3.748 2.817-.795v2.293l-2.959.835-2.863-3.165 1.197-.338.795.878a1 1 0 0 0 1.013.292m9.245-.316-1.654.467v-2.293zm0-3.748-1.654.467V8.539zm0-3.748L14.024 7.24l-2.71-3.208 2.052-.58zm-5.028 2.174L7.925 5.005l1.92-.542 3.33 3.942v6.543l-1.973.569z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MoneyIcon = /* @__PURE__ */ Object.assign(MoneyIconComponent, {
  displayName: 'MoneyIcon',
});
